// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"145":"1f66e57f","303":"81b4ecbf","338":"9980fa41","396":"8f05709a","583":"49ac03e0"}[chunkId] + ".chunk.js";
};